import { ClickKeywordEvent, SearchKeywordEvent } from '../model/log-event'

const environment = process.env.NEXT_PUBLIC_ENVIRONMENT

export const searchKeywords = async (
  data: Omit<SearchKeywordEvent, 'eventType'>,
) => {
  if (environment === 'local') {
    return
  }

  try {
    await fetch('/api/log/search-keywords', {
      method: 'POST',
      body: JSON.stringify({
        eventType: 'search-keyword',
        ...data,
      }),
      keepalive: true,
    })
  } catch (error) {
    console.error('Failed to log search keyword:', error)
  }
}

export const clickKeywords = async (
  data: Omit<ClickKeywordEvent, 'eventType'>,
) => {
  if (environment === 'local') {
    return
  }

  try {
    await fetch('/api/log/click-keyword', {
      method: 'POST',
      body: JSON.stringify({
        eventType: 'click-keyword',
        ...data,
      }),
      keepalive: true,
    })
  } catch (error) {
    console.error('Failed to log click keyword:', error)
  }
}
